// extracted by mini-css-extract-plugin
export default {"container":"src-components-PageBox-index-module_container--l2MAq","formWrapper":"src-components-PageBox-index-module_formWrapper--bAPaf"};